import { GlobalAuthenticationContext } from "./AuthenticationContext";

class AuthenticatedHttpClient {

  async authorizedGet(url) {
    return await this.authorizedFetch("GET", url);
  }

  async authorizedPost(url, body) {
    return await this.authorizedFetch("POST", url, body);
  }

  async authorizedPut(url, body) {
    return await this.authorizedFetch("PUT", url, body);
  }

  async authorizedFetch(method, url, body) {
    // Check if the current page url is https://businesscase-dev.fiskaltrust.cloud/
    let base = "https://businesscase-api-dev.fiskaltrust.cloud/";
    if (window.location.host !== "businesscase-dev.fiskaltrust.cloud") {
      base = "https://businesscase-api.fiskaltrust.cloud/";
    }

    const tokenResponse = await GlobalAuthenticationContext.getToken();
    var headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + tokenResponse.accessToken
    };
    return await fetch(`${base}${url}`, {
      method: method,
      headers: headers,
      body: body
    });
  }
}

export const GlobalAuthenticatedHttpClient = new AuthenticatedHttpClient();